module.exports = __webpack_public_path__ + "img/동국제강_로그인.65ac8020.svg";